import { createContext } from "react";

type OpenDialogsContextValue = {
  /**
   * Registers an open dialog. `dismiss` is captured by the caller at open
   * time, while the dialog's result type is still known.
   */
  track: (handle: Promise<unknown>, dismiss: () => void) => void;
  dismissAll: () => void;
};

export const OpenDialogsContext = createContext<
  OpenDialogsContextValue | undefined
>(undefined);

export type { OpenDialogsContextValue };
